import { UserSlice } from "./user-slice";

export default UserSlice.reducer;

export { authenticate } from "./user-thunks";
